/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_LabelInputs */

const en_fc_dl_label = /** @type {(inputs: Fc_Dl_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download guide`)
};

/**
* | output |
* | --- |
* | "Download guide" |
*
* @param {Fc_Dl_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_label = /** @type {((inputs?: Fc_Dl_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_label(inputs)
});
export { fc_dl_label as "fc.dl.label" }